import Phaser from 'phaser';
import { DEPTH } from './theme';

/**
 * 头顶飘字（拾取提示等）
 * - 动画用 delta 推进（不依赖 tween / Clock，任何环境都会正常消失）
 * - 多条会依次向上堆叠，避免重叠
 */
interface ToastItem {
  t: Phaser.GameObjects.Text;
  life: number;
  total: number;
  baseY: number;
}

export interface ToastStyle {
  fontSize?: string;
  /** 上飘距离 */
  rise?: number;
  /** 存活时长 ms */
  life?: number;
  /** 多条之间的堆叠间距 */
  gap?: number;
}

const DEFAULT: Required<ToastStyle> = {
  fontSize: '15px',
  rise: 46,
  life: 1250,
  gap: 19,
};

export default class Toasts {
  private items: ToastItem[] = [];

  constructor(private readonly scene: Phaser.Scene) {}

  /** 在世界坐标 (x, y) 处推出一条飘字 */
  push(x: number, y: number, text: string, color = '#66ff88', style: ToastStyle = {}) {
    const s = { ...DEFAULT, ...style };
    const baseY = y - 44 - this.items.length * s.gap;
    const t = this.scene.add
      .text(x, baseY, text, {
        fontSize: s.fontSize,
        fontFamily: 'monospace',
        color,
        backgroundColor: '#000000aa',
        padding: { x: 7, y: 3 },
      })
      .setOrigin(0.5)
      .setDepth(DEPTH.toast);
    this.items.push({ t, life: s.life, total: s.life, baseY });
  }

  /** 每帧推进动画 */
  update(delta: number) {
    for (let i = this.items.length - 1; i >= 0; i--) {
      const it = this.items[i];
      it.life -= delta;
      const k = 1 - Math.max(0, it.life) / it.total;
      it.t.y = it.baseY - DEFAULT.rise * k;
      it.t.alpha = it.life < 320 ? Math.max(0, it.life / 320) : 1;
      if (it.life <= 0) {
        it.t.destroy();
        this.items.splice(i, 1);
      }
    }
  }

  clear() {
    this.items.forEach((it) => it.t.destroy());
    this.items = [];
  }

  get count() {
    return this.items.length;
  }
}
